import script from "./jibenxinxi.vue?vue&type=script&setup=true&lang=js"
export * from "./jibenxinxi.vue?vue&type=script&setup=true&lang=js"

import "./jibenxinxi.vue?vue&type=style&index=0&id=1a05d386&lang=less&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1a05d386"]])

export default __exports__